import React from 'react'
import { Trans } from 'react-i18next'

import { getUserName, getPositionName } from 'services/Utilities'
import { Format } from 'services/Dates'

import { t } from 'translations'

const EventSummary = ({ employeeId, start, end, positionId, multiDayIndex, inScheduleTemplate, isTime, outFormat }) => {
  return (
    <div className="d-flex flex-wrap" style={{ whiteSpace: 'pre-wrap' }}>
      <Trans t={t} i18nKey={`manager.${inScheduleTemplate ? 'scheduleTemplates' : 'schedule'}.EVENT_SUMMARY`}>
        <b>{{ name: employeeId ? getUserName(employeeId) : t('manager.schedule.UNASSIGNED_SHIFT') }}</b>
        <b>
          {{ start: !isTime ? Format(start, { outFormat: outFormat || 'humanDateTime' }) : start }}
          {{ end: !isTime ? Format(end, { outFormat: outFormat || 'humanDateTime' }) : end }}
        </b>
        {{ positionName: getPositionName(positionId) }}
        {{ multiDayIndex: multiDayIndex + 1 }}
      </Trans>
    </div>
  )
}

export default EventSummary
